import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getPurchaseOrders({ commit },{ projectId, params = {} }) {
    return axios.get(`/projects/${projectId}/purchase-orders/search`, { params })
  },
  getPurchaseOrder({ commit }, id) {
    return axios.get(`/purchase-orders/${id}`)
  },
  createPurchaseOrder({ commit }, data) {
    return axios.post('/purchase-orders', data)
  },
  updatePurchaseOrder({ commit }, data) {
    return axios.put(`/purchase-orders/${data.id}`, data)
  },
  updatePurchaseOrderStatus({ commit }, data) {
    return axios.put(`/purchase-orders/${data.id}/change-status`, data)
  },
  updateItemsAdditional({ commit }, {id, data}) {
    return axios.put(`/purchase-orders/${id}/items-additional`, data)
  },
  approvePurchaseOrder({ commit }, data) {
    return axios.post(`/purchase-orders/${data.id}/approve`)
  },
  deletePurchaseOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/purchase-orders/${payload.id}/delete`, payload)
  },
  rejectPurchaseOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/purchase-orders/${payload.id}/reject`, payload)
  },
  cancelPurchaseOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/purchase-orders/${payload.id}/cancel`, payload)
  },
  downloadPurchaseOrder({ commit }, purchaseOrder) {
    return axios
      .get(`/purchase-orders/${purchaseOrder.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${purchaseOrder.document_name}.pdf`)
      })
  },
  xeroSyncPurchaseOrder({ commit }, purchaseOrder) {
    return axios.post(`/purchase-orders/${purchaseOrder.id}/xero-sync`, {})
  }
}
